import React from "react";
import { useSelector } from "react-redux";
import { translate } from "../../../../common/providers";
import { CustomButton, CustomTextField, CustomTooltip } from "../../../../common/components";
import styles from "./Search.module.css";

const Search = ({ chatPayload, loading, onAskQuestion, onChangeChatPayload, selectedChat = 0 }) => {
	const hasAvailableAIQuota = useSelector(({ context }) => context?.hasAvailableAIQuota);
	const handleChangeTextFilter = (e) => {
		const { value } = e.target;
		onChangeChatPayload(value);
	};
	return (
		<CustomTooltip
			title={
				!!(selectedChat && chatPayload?.length < 3 && !loading) &&
				translate("ai-chat.search.conversation-mode-disabled")
			}
		>
			<div className={styles.container}>
				<div className={styles.textLine__container}>
					<CustomTextField
						fullWidth
						multiline
						className={styles.textField}
						disabled={loading || selectedChat !== 0}
						maxRows={6}
						minRows={1}
						placeholder={
							loading
								? translate("ai-chat.search.loading")
								: translate("ai-chat.search.ask-question.placeholder")
						}
						slotProps={{
							input: { style: { fontSize: "var(--font-size-sm)" } },
						}}
						value={(loading && "") || chatPayload}
						onChange={handleChangeTextFilter}
					/>
					<CustomTooltip
						title={
							(!hasAvailableAIQuota && translate("common:company.quotas.consumption-reached.tooltip")) ||
							""
						}
					>
						<div>
							<CustomButton
								disabled={
									chatPayload?.length < 3 || loading || selectedChat !== 0 || !hasAvailableAIQuota
								}
								variant="contained"
								onClick={onAskQuestion}
							>
								{loading
									? translate("ai-chat.search.loading")
									: translate("ai-chat.search.send-button")}
							</CustomButton>
						</div>
					</CustomTooltip>
				</div>
			</div>
		</CustomTooltip>
	);
};

export default Search;
